
import { SignatureSource } from "@/gql"
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({})
export default class Signature extends Vue {
  @Prop() readonly source?: SignatureSource | null
  @Prop() readonly signer?: string | null
}
